.scan-configuration-asset-form {
  padding: 0 calc(2 * var(--spacer));
  display: flex;

  &--title {
    align-self: center;
    padding-right: calc(10 * var(--spacer));
    color: var(--main-titles-inputs-600);
  }

  &--row {
    padding: 10px 0 var(--spacer) 0;
  }

  &--field {
    margin-right: calc(2 * var(--spacer));
    position: relative;
    height: calc(4 * var(--spacer));

    gz-enum-filter {
      width: 100%;
    }
  }
}

.scan-configuration-asset-form-wrapper {
  display: flex;
  flex-direction: column;
}

#add-assets-error {
  width: 50%;
  margin-left: var(--spacer);
}

.asset-form {
  display: flex;
  flex-direction: row;
}

[hidden] {
  display: none;
}

:host {
  height: 0;
  margin-bottom: 50px;
}

@media screen and (max-height: 768px) {
  gz-dropdown {
    --gz-dropdown-max-height: 200px !important;
  }
}
